// extracted by mini-css-extract-plugin
export default {"container":"DevTools_container__Eammg","toggle":"DevTools_toggle__7seQz"};